// src/hooks/useHireAgreements.js
import { useEffect, useState } from "react";
import { fetchHireAgreements } from "../api/hireAgreements";

export default function useHireAgreements() {
  const [agreements, setAgreements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        setLoading(true);
        const data = await fetchHireAgreements();
        if (!cancelled) {
          setAgreements(data || []);
        }
      } catch (err) {
        console.error(err);
        if (!cancelled) setError("Failed to fetch hire agreements");
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { agreements, loading, error };
}
